import { createAsyncThunk } from "@reduxjs/toolkit";
import { MarathonsAPI } from "api/api/marathonsApi/marathonsApi";
import {
  DeleteMarathonsNonActivatedPromocodesParams,
} from "api/api/marathonsApi/types";
import axios from "axios";

export const deleteMarathonsNonActivatedPromocodes = createAsyncThunk<
  void,
  DeleteMarathonsNonActivatedPromocodesParams
>(
  "marathons/deleteMarathonsNonActivatedPromocodes",
  async ({ marathonId }, { rejectWithValue }) => {
    try {
      const data = await MarathonsAPI.deleteMarathonsNonActivatedPromocodes({ marathonId });
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("Error while deleting marathon non-activated promocodes", error.response?.data);
        return rejectWithValue(error.response?.data || "Unknown error");
      }
      console.error("Error while deleting marathon non-activated promocodes", error);
      return rejectWithValue("Что-то пошло не так... Попробуйте обновить страницу");
    }
  }
);
